module.exports = __webpack_public_path__ + "img/amy.6f94d545.png";